/**
 * A Prism grammar for Cedar, the policy language.
 *
 * Written here because Prism ships none: Cedar is not in refractor's language set, so a
 * `language="cedar"` code block would otherwise render as unhighlighted text. The shape
 * follows refractor's contract (a default-exported function taking Prism, carrying a
 * `displayName`), which is what `PrismLight.registerLanguage` expects.
 */

/** The slice of Prism a grammar module touches. */
interface PrismLike {
    languages: Record<string, unknown>;
}

const cedar = (Prism: PrismLike): void => {
    Prism.languages.cedar = {
        comment: /\/\/.*/,
        // Greedy so an operator or keyword inside a quoted id, `"like-this"`, stays string.
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true,
        },
        // Each segment of an entity path: the `StackOne` and `Action` of
        // `StackOne::Action::"invokeTool"`. Matching per segment rather than the whole path
        // keeps the pattern readable, and `::` falls through to punctuation.
        'class-name': /\b[A-Za-z_]\w*(?=\s*::)/,
        keyword: /\b(?:permit|forbid|when|unless|if|then|else|in|like|has|is)\b/,
        // The four scope variables read as language, not as identifiers a policy author chose.
        builtin: /\b(?:principal|action|resource|context)\b/,
        boolean: /\b(?:true|false)\b/,
        number: /\b\d+\b/,
        operator: /&&|\|\||[=!<>]=|[<>!]|[+\-*]/,
        punctuation: /[{}[\]();,.:]/,
    };
};

cedar.displayName = 'cedar';
cedar.aliases = [] as string[];

export default cedar;
